// import {
// 	Modal,
// 	ModalOverlay,
// 	ModalContent,
// 	ModalHeader,
// 	ModalBody,
// 	ModalFooter,
// 	ModalCloseButton,
// 	HStack,
// 	VStack,
// 	Text,
// 	Heading,
// 	Icon,
// 	Badge,
// 	Button,
// 	SimpleGrid,
// 	Box,
// 	Avatar,
// } from '@chakra-ui/react';
// import {
// 	FiDollarSign,
// 	FiTarget,
// 	FiGlobe,
// 	FiUser,
// 	FiPhone,
// 	FiMail,
// 	FiFlag,
// 	FiCheck,
// 	FiX,
// } from 'react-icons/fi';
// import { FaStar } from 'react-icons/fa';
// import { getLeadValue, getInitials } from './leadFields';

// const DetailRow = ({ icon, label, value, color = 'accent.gold' }) => (
// 	<HStack
// 		spacing={3}
// 		align='center'
// 		bg='bg.elevated'
// 		p={3}
// 		borderRadius='lg'
// 		borderWidth='1px'
// 		borderColor='border.default'
// 	>
// 		<Box
// 			as='span'
// 			display='inline-flex'
// 			alignItems='center'
// 			justifyContent='center'
// 			w={8}
// 			h={8}
// 			borderRadius='md'
// 			bg='blackAlpha.300'
// 			flexShrink={0}
// 		>
// 			<Icon as={icon} boxSize={4} color={color} />
// 		</Box>
// 		<VStack spacing={0} align='start' flex={1} minW={0}>
// 			<Text fontSize='xs' color='text.muted' lineHeight='1.2'>
// 				{label}
// 			</Text>
// 			<Text
// 				fontSize='sm'
// 				fontWeight='semibold'
// 				color='text.body'
// 				noOfLines={2}
// 				wordBreak='break-word'
// 			>
// 				{value ?? 'N/A'}
// 			</Text>
// 		</VStack>
// 	</HStack>
// );

// // "View" modal for a single pending approval lead. Approve / Reject act on the
// // same handler the bar uses, so behaviour stays identical to the old flow.
// const LeadDetailsModal = ({ lead, isOpen, onClose, onDecision, isSubmitting }) => {
// 	if (!lead) return null;

// 	const leadName = getLeadValue(lead, 'leadName') || 'New Lead';
// 	const agentName = lead?.agentName || getLeadValue(lead, 'agentName');

// 	const decide = (action) => {
// 		onDecision?.(lead._id, action);
// 		onClose?.();
// 	};

// 	return (
// 		<Modal isOpen={isOpen} onClose={onClose} isCentered size='lg' motionPreset='slideInBottom'>
// 			<ModalOverlay backdropFilter='blur(8px)' bg='bg.overlay' />
// 			<ModalContent
// 				borderRadius='2xl'
// 				bg='bg.surface'
// 				borderWidth='1px'
// 				borderColor='border.gold'
// 				boxShadow='deep'
// 				mx={3}
// 			>
// 				<ModalHeader pb={2}>
// 					<HStack spacing={3} align='center'>
// 						<Avatar
// 							size='md'
// 							name={leadName}
// 							bg='accent.gold'
// 							color='black'
// 							getInitials={() => getInitials(leadName)}
// 						/>
// 						<VStack align='start' spacing={0.5}>
// 							<Heading size='sm' color='text.heading' noOfLines={1}>
// 								{leadName}
// 							</Heading>
// 							<HStack spacing={2}>
// 								<Badge colorScheme='blue' fontSize='2xs' borderRadius='full' px={2}>
// 									NEW
// 								</Badge>
// 								{agentName && (
// 									<Text fontSize='xs' color='text.muted' noOfLines={1}>
// 										Requested by <b>{agentName}</b>
// 									</Text>
// 								)}
// 							</HStack>
// 						</VStack>
// 					</HStack>
// 				</ModalHeader>
// 				<ModalCloseButton top={4} right={4} />

// 				<ModalBody>
// 					<SimpleGrid columns={{ base: 1, sm: 2 }} spacing={3}>
// 						<DetailRow icon={FiDollarSign} label='Budget' value={getLeadValue(lead, 'budget')} color='green.400' />
// 						<DetailRow icon={FiTarget} label='Campaign' value={getLeadValue(lead, 'leadCampaign')} color='blue.400' />
// 						<DetailRow icon={FiGlobe} label='Ad Name' value={getLeadValue(lead, 'leadSourceDetails')} color='purple.400' />
// 						<DetailRow icon={FaStar} label='Interest' value={getLeadValue(lead, 'interest')} color='orange.400' />
// 						<DetailRow icon={FiPhone} label='Phone' value={getLeadValue(lead, 'leadPhoneNumber')} color='teal.400' />
// 						<DetailRow icon={FiMail} label='Email' value={getLeadValue(lead, 'leadEmail')} color='cyan.400' />
// 						<DetailRow icon={FiFlag} label='Nationality' value={getLeadValue(lead, 'nationality')} color='pink.400' />
// 						<DetailRow icon={FiUser} label='Requested By' value={agentName} color='yellow.400' />
// 					</SimpleGrid>
// 				</ModalBody>

// 				<ModalFooter gap={3}>
// 					<Button
// 						flex={1}
// 						leftIcon={<Icon as={FiX} />}
// 						variant='outline'
// 						colorScheme='red'
// 						onClick={() => decide('reject')}
// 						isDisabled={isSubmitting}
// 						size='sm'
// 					>
// 						Reject
// 					</Button>
// 					<Button
// 						flex={1}
// 						leftIcon={<Icon as={FiCheck} />}
// 						bg='green.600'
// 						color='white'
// 						_hover={{ bg: 'green.700' }}
// 						onClick={() => decide('approve')}
// 						isLoading={isSubmitting}
// 						size='sm'
// 					>
// 						Approve
// 					</Button>
// 				</ModalFooter>
// 			</ModalContent>
// 		</Modal>
// 	);
// };

// export default LeadDetailsModal;
import {
	Modal,
	ModalOverlay,
	ModalContent,
	ModalHeader,
	ModalBody,
	ModalFooter,
	ModalCloseButton,
	HStack,
	VStack,
	Text,
	Heading,
	Icon,
	Badge,
	Button,
	SimpleGrid,
	Box,
	Avatar,
	useBreakpointValue,
} from '@chakra-ui/react';
import {
	FiDollarSign,
	FiTarget,
	FiGlobe,
	FiUser,
	FiPhone,
	FiMail,
	FiFlag,
	FiCheck,
	FiX,
} from 'react-icons/fi';
import { FaStar } from 'react-icons/fa';
import { getLeadValue, getInitials } from './leadFields';
import { useModalColors } from 'hooks/useModalColors';
import { useLeadStatuses } from 'hooks/leads/useLeadStatuses';

/* -------------------------------------------------------------------------- */
/* DetailRow – gold-accented cards for dark theme                            */
/* -------------------------------------------------------------------------- */
const DetailRow = ({ icon, label, value, color = 'accent.gold' }) => {
	const mc = useModalColors();
	const isMobile = useBreakpointValue({ base: true, sm: false });

	return (
		<HStack
			spacing={3}
			align="center"
			bg={mc.bgDeep}
			p={isMobile ? 2.5 : 3}
			borderRadius="lg"
			borderWidth="1px"
			borderColor={mc.borderColor}
			boxShadow="sm"
			transition="all 0.2s"
			_hover={{ borderColor: 'rgba(255, 149, 0, 0.4)', boxShadow: 'md' }}
			minH="52px"
		>
			<Box
				as="span"
				display="inline-flex"
				alignItems="center"
				justifyContent="center"
				w={8}
				h={8}
				borderRadius="md"
				bg="rgba(255, 149, 0, 0.1)"
				flexShrink={0}
			>
				<Icon as={icon} boxSize={4} color={color} />
			</Box>
			<VStack spacing={0} align="start" flex={1} minW={0}>
				<Text fontSize="xs" color={mc.mutedText} lineHeight="1.2">
					{label}
				</Text>
				<Text
					fontSize="sm"
					fontWeight="semibold"
					color={mc.headingText}
					noOfLines={2}
					wordBreak="break-word"
				>
					{value || 'N/A'}
				</Text>
			</VStack>
		</HStack>
	);
};

/* -------------------------------------------------------------------------- */
/* LeadDetailsModal – Gold Header + Navy Body                                */
/* -------------------------------------------------------------------------- */
const LeadDetailsModal = ({ lead, isOpen, onClose, onDecision, isSubmitting }) => {
	const mc = useModalColors();
	const { leadStatuses } = useLeadStatuses();

	if (!lead) return null;

	const leadName = getLeadValue(lead, 'leadName') || 'New Lead';
	const agentName = lead?.agentName || getLeadValue(lead, 'agentName');

	const selectedOption = leadStatuses?.find(
		(item) => item.value === lead?.eLeadStatus,
	);

	const mainStatus = selectedOption?.label || 'New';

	const decide = (action) => {
		onDecision?.(lead._id, action);
		onClose?.();
	};

	return (
		<Modal isOpen={isOpen} onClose={onClose} isCentered size="lg" motionPreset="slideInBottom">
			<ModalOverlay backdropFilter="blur(8px)" bg={mc.overlayBg} />

			<ModalContent
				borderRadius="2xl"
				bg={mc.bg}
				borderWidth="1px"
				borderColor={mc.borderColor}
				boxShadow={mc.modalShadow}
				mx={3}
				position="relative"
				overflow="hidden"
			>
				{/* Gold accent line at the top */}
				<Box
					position="absolute"
					top={0}
					left={0}
					right={0}
					h="4px"
					bg="linear-gradient(90deg, var(--chakra-colors-accent-goldLight), var(--chakra-colors-accent-gold), var(--chakra-colors-accent-hover))"
					borderRadius="2xl 2xl 0 0"
				/>

				{/* Header — Gold Gradient */}
				<ModalHeader pt={6} pb={2} px={6}>
					<HStack spacing={4} align="center">
						<VStack align="start" spacing={0.5} flex={1}>
							<Heading size="sm" color={mc.headingText} noOfLines={1}>
								{leadName}
							</Heading>
							<HStack spacing={2} mt={2} flexWrap="wrap">
								<Badge
									variant="gold"
									fontSize="sm"
									borderRadius="full"
									px={2}
									textTransform="capitalize"
									letterSpacing="wider"
								>
									{mainStatus}
								</Badge>

							</HStack>
						</VStack>
					</HStack>
				</ModalHeader>

				<ModalCloseButton
					top={5}
					right={5}
					bg={'bg.surface'}
					color={'gray.100'}
					borderRadius="full"
					_focus={{ boxShadow: 'none' }}
				/>

				<ModalBody py={4} px={6}>
					<SimpleGrid columns={{ base: 1, sm: 2 }} spacing={3}>
						<DetailRow
							icon={FiDollarSign}
							label="Budget"
							value={getLeadValue(lead, 'budget')}
							color="green.400"
						/>
						<DetailRow
							icon={FiTarget}
							label="Campaign"
							value={getLeadValue(lead, 'leadCampaign')}
							color="blue.400"
						/>
						<DetailRow
							icon={FiGlobe}
							label="Ad Name"
							value={getLeadValue(lead, 'leadSourceDetails')}
							color="purple.400"
						/>
						<DetailRow
							icon={FaStar}
							label="Interest"
							value={getLeadValue(lead, 'interest')}
							color="orange.400"
						/>
						<DetailRow
							icon={FiPhone}
							label="Phone"
							value={getLeadValue(lead, 'leadPhoneNumber')}
							color="teal.400"
						/>
						<DetailRow
							icon={FiMail}
							label="Email"
							value={getLeadValue(lead, 'leadEmail')}
							color="cyan.400"
						/>
						<DetailRow
							icon={FiFlag}
							label="Nationality"
							value={getLeadValue(lead, 'nationality')}
							color="pink.400"
						/>
						<DetailRow
							icon={FiUser}
							label="Requested By"
							value={agentName}
							color="accent.goldLight"
						/>
					</SimpleGrid>
				</ModalBody>

				<ModalFooter gap={3} pt={2} pb={6} px={6}>
					<Button
						flex={1}
						leftIcon={<Icon as={FiX} />}
						variant="ghost"
						onClick={() => decide('reject')}
						isDisabled={isSubmitting}
						size="md"
						borderRadius="lg"
						color="red.400"
						_hover={{ bg: 'rgba(238, 93, 80, 0.1)', color: 'red.300' }}
					>
						Reject
					</Button>
					<Button
						flex={1}
						leftIcon={<Icon as={FiCheck} />}
						background={mc.primaryBtnBg}
						color={mc.primaryBtnText}
						_hover={{
							background: mc.primaryBtnHoverBg,
							boxShadow: mc.primaryBtnShadow,
							transform: 'translateY(-2px)',
						}}
						_active={{ transform: 'translateY(0)' }}
						onClick={() => decide('approve')}
						isLoading={isSubmitting}
						size="md"
						borderRadius="lg"
						fontWeight="bold"
					>
						Approve
					</Button>
				</ModalFooter>
			</ModalContent>
		</Modal>
	);
};

export default LeadDetailsModal;